module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// /home/gitlab_ci_multi_runner/builds/88e00e75/0/bryx911/ua-download/~/core-js/library/modules/$.redefine.js
// module id = 232
// module chunks = 0